import { ResourcePermission } from './access-control';
import { ROLE_PERMISSIONS, Right } from './security.const';

export function ValidateResourcePermissionInput(rp: ResourcePermission, inputSource: string) {    
    if (rp && rp.rights && rp.rights instanceof Array && rp.rights.length > 0) {
        return;
    } else {
        throw new Error(`The input Resource Permission used in ${inputSource} is not valid. You need to provide it in following format: \n
                                 { rights: ['right1', 'right1'], policy:'Any|All'] },
                            `);
    }
}

export function GetPermissionsByRole(role: string): Right {
    const rights = ROLE_PERMISSIONS[role];
    if (!rights) {
        return null;
    }
    return rights;
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/security.helper.ts